export const state = () => ({
  userInformation: {
    userData: {},
    awards: [],
    isLoaded: false,
  },
});
